import React from 'react';
import ArchiveRow from './ArchiveRow';
import type { DecoratedArchiveItem } from './types';
import { GRID_TEMPLATE } from './constants';

interface Props {
  items: DecoratedArchiveItem[];
  onArchive: (id: string) => void;
  onDismiss: (id: string) => void;
}

export default function ArchiveTable({ items, onArchive, onDismiss }: Props): React.ReactElement {
  return (
    <div className="mt-5 bg-white border border-lineSoft rounded-lg overflow-hidden">
      <div
        className="grid gap-4 px-5 py-2.5 bg-surface-paper border-b border-line text-[10.5px] font-extrabold uppercase tracking-wider text-helper"
        style={{ gridTemplateColumns: GRID_TEMPLATE }}
      >
        <div>Account</div>
        <div>Type</div>
        <div>Last activity</div>
        <div>Transactions</div>
        <div className="text-right">Balance</div>
        <div className="text-right">Action</div>
      </div>
      {items.map((item) => (
        <ArchiveRow
          key={item.id}
          item={item}
          onArchive={() => onArchive(item.id)}
          onDismiss={() => onDismiss(item.id)}
        />
      ))}
    </div>
  );
}